import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { severity } from '../../models/severity.enum';
import { isProdOrDevEnv } from '../../../environment.enum';
import { ServiceManager } from '../../../services/service-manager';
import ResetPassword from '../ResetPassword/ResetPassword';
import VerifyEmail from '../VerifyEmail/VerifyEmail';
import styles from './Action.module.css';

enum modes {
    none = 'none',
    resetPassword = 'resetPassword',
    verifyEmail = 'verifyEmail',
}

const Action = ({ user, setUser }) => {

    const [searchParams] = useSearchParams();
    const [mode, setMode] = useState<modes>(modes.none);
    const firstRenderRef = useRef(true);

    const navigate = useNavigate();

    useEffect(() => {
        if (!isProdOrDevEnv() && firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
        const mode = searchParams.get('mode') as modes;
        setMode(mode);
        if (!Object.keys(modes).includes(mode)) {
            ServiceManager.snackbarService.openSnackbar('Actie niet bekend', severity.error);
            navigate('/auth/login');
        }
    }, [searchParams])


    const getModeComponent = () => {
        switch (mode) {
            case modes.resetPassword:
                return (<ResetPassword />)
            case modes.verifyEmail:
                return (<VerifyEmail user={user} setUser={setUser} />)
            default:
                break;

        }
    }

    return (
        <div className={styles.Action} data-testid="Action">
            {(mode === modes.resetPassword || mode === modes.verifyEmail) && getModeComponent()}
        </div>
    )
};

export default Action;
